// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookListItemFragmentFragmentDoc } from "../../WorkbookListTable/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbooksForServerGroupQueryVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
}>;

export type WorkbooksForServerGroupQuery = {
  __typename?: "GraphqlQuery";
  getWorkbooks: Array<{
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    variantsCount: number;
    draft: boolean;
    channel?: string | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
    database: { __typename?: "Database"; id: string; datname?: string | null };
  }>;
};

export const WorkbooksForServerGroupDocument = gql`
  query WorkbooksForServerGroup($serverGroupId: ID!) {
    getWorkbooks(serverGroupId: $serverGroupId) {
      ...WorkbookListItemFragment
    }
  }
  ${WorkbookListItemFragmentFragmentDoc}
`;

/**
 * __useWorkbooksForServerGroupQuery__
 *
 * To run a query within a React component, call `useWorkbooksForServerGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbooksForServerGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbooksForServerGroupQuery({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *   },
 * });
 */
export function useWorkbooksForServerGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbooksForServerGroupQuery,
    WorkbooksForServerGroupQueryVariables
  > &
    (
      | { variables: WorkbooksForServerGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorkbooksForServerGroupQuery,
    WorkbooksForServerGroupQueryVariables
  >(WorkbooksForServerGroupDocument, options);
}
export function useWorkbooksForServerGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbooksForServerGroupQuery,
    WorkbooksForServerGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbooksForServerGroupQuery,
    WorkbooksForServerGroupQueryVariables
  >(WorkbooksForServerGroupDocument, options);
}
// @ts-ignore
export function useWorkbooksForServerGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbooksForServerGroupQuery,
    WorkbooksForServerGroupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbooksForServerGroupQuery,
  WorkbooksForServerGroupQueryVariables
>;
export function useWorkbooksForServerGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbooksForServerGroupQuery,
        WorkbooksForServerGroupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbooksForServerGroupQuery | undefined,
  WorkbooksForServerGroupQueryVariables
>;
export function useWorkbooksForServerGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbooksForServerGroupQuery,
        WorkbooksForServerGroupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbooksForServerGroupQuery,
    WorkbooksForServerGroupQueryVariables
  >(WorkbooksForServerGroupDocument, options);
}
export type WorkbooksForServerGroupQueryHookResult = ReturnType<
  typeof useWorkbooksForServerGroupQuery
>;
export type WorkbooksForServerGroupLazyQueryHookResult = ReturnType<
  typeof useWorkbooksForServerGroupLazyQuery
>;
export type WorkbooksForServerGroupSuspenseQueryHookResult = ReturnType<
  typeof useWorkbooksForServerGroupSuspenseQuery
>;
export type WorkbooksForServerGroupQueryResult = Apollo.QueryResult<
  WorkbooksForServerGroupQuery,
  WorkbooksForServerGroupQueryVariables
>;
